import Requester from "./Requester";

interface CreateDTO {
    product_id: number
    link: string
    asin: string
    price: string
    salePrice?: string
}

const URL = 'api/amazon';



export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(URL), values)
}

export default {
    create,
}